// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2OHXh","label":"LabeledBox_label__R4ODi"};